import {
	GetCommissionConfigsQuery,
	GetMyCommissionConfigQuery,
	GetUsersForCommissionsQuery
} from "~/gql/queries/commissions.generated";

export const commissionsEndpoints = {
	ClearCustomerCommissionOverride: {
		invalidatesTags: ["CommissionConfigs"] as AddTagTypes
	},
	CreateCommissionConfig: {
		invalidatesTags: ["CommissionConfigs"] as AddTagTypes
	},
	GetCommissionConfigs: {
		providesTags: ["CommissionConfigs"] as AddTagTypes,
		transformResponse: (res: GetCommissionConfigsQuery) => res
	},
	GetMyCommissionConfig: {
		providesTags: ["CommissionConfigs"] as AddTagTypes,
		transformResponse: (res: GetMyCommissionConfigQuery) => res
	},
	GetUsersForCommissions: {
		providesTags: ["Users"] as AddTagTypes,
		transformResponse: (res: GetUsersForCommissionsQuery) => res
	},
	SetCommissionDefaultRate: {
		invalidatesTags: ["CommissionConfigs"] as AddTagTypes
	},
	SetCustomerCommissionOverride: {
		invalidatesTags: ["CommissionConfigs"] as AddTagTypes
	}
};
